import React from "react";
import { Mail, Phone } from "lucide-react";
import { company } from "../../mock";

export default function TopBar() {
  return (
    <div className="hidden lg:block border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between text-xs text-gray-600">
        <div className="flex items-center gap-6">
          <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-brand">
            <Mail size={14} className="text-brand" /> {company.email}
          </a>
          <a href={`mailto:${company.careerEmail}`} className="flex items-center gap-2 hover:text-brand">
            <Mail size={14} className="text-brand" /> {company.careerEmail}
          </a>
          <a href={`tel:${company.phone}`} className="flex items-center gap-2 hover:text-brand">
            <Phone size={14} className="text-brand" /> {company.phone}
          </a>
        </div>
        <div className="text-gray-500">{company.locations}</div>
      </div>
    </div>
  );
}
